export default __webpack_public_path__ + "static/media/twin.d9b75ce8.jpeg";